/**
 * Bookkeeping for one attach run: which parsed documents made it onto the ride
 * in FULL.
 *
 * This exists because a partial failure leaves the panel's Attach button live
 * with the results untouched. Without a record of what already landed, pressing
 * it again re-posts every write the first run got through — one rejected hotel
 * voucher and three accepted attractions become one rejected voucher and SIX
 * attractions on the trip.
 *
 * Granularity is the document, not the individual write: operations carry the
 * index of the result they were built from (see buildAttachOperations), and a
 * result counts as done only when every operation it produced succeeded. A
 * document that failed halfway is left in place to be retried whole, which can
 * still duplicate that one document's successful writes — far better than
 * duplicating every other document's.
 *
 * Operations belonging to no single document — the trip-level general
 * information sections — carry a null resultIndex and are tracked by nobody
 * here; the store retires them separately.
 */

function isTracked(op) {
  return !!op && typeof op.resultIndex === 'number';
}

function createAttachOutcomes() {
  // resultIndex -> false once anything it produced failed, true while every
  // operation seen so far has succeeded.
  const byResult = new Map();

  return {
    /** Record how one operation went. Anything untracked is ignored. */
    record(op, succeeded) {
      if (!isTracked(op)) return;
      if (byResult.get(op.resultIndex) === false) return;
      byResult.set(op.resultIndex, !!succeeded);
    },

    /**
     * The results whose every operation succeeded, in ascending order. A result
     * that produced no operation at all never appears — there is nothing to
     * protect it from.
     */
    succeededResultIndexes() {
      const done = [];
      byResult.forEach((ok, index) => { if (ok) done.push(index); });
      return done.sort((a, b) => a - b);
    },
  };
}

module.exports = { createAttachOutcomes };
